<template>
  <div class="promise-text">
    <div id="print" style="width: 16.9cm;margin:0 auto">
      <p style="margi-bottom: 40pt; orphans:0; text-align:center; widows:0">
        <span style="font-family:宋体;font-weight: bold;font-size:18pt">
          中国化学工程集团有限公司
        </span>
      </p>
      <p style="margi-bottom: 35pt; orphans:0; text-align:center; widows:0">
        <span style="font-family:宋体;font-weight: bold;font-size:18pt">因公出国（境）行前安全保密承诺书</span>
      </p>
      <br>
      <div style="font-family:宋体;text-indent: 2em;font-size: 10.5pt;line-height: 2.2">通过国家安全保密教育和反间谍安全防范教育培训，我已学习《中华人民共和国国家安全法》《中国人民共和国保守国家秘密法》《中华人民共和国反间谍法》《反间谍安全防范工作规定》等相关法律法规，了解公民在国外期间安全保密和防范注意事项，知悉应承担的保密义务和相应法律责任。本人郑重承诺：</div>
      <div style="font-family:宋体;text-indent: 2em;font-size: 10.5pt;line-height: 2.2">
        <div>一、严格遵守我国安全保密法律法规，履行安全保密义务，尤其在出国（境）期间，自觉做好反间谍安全防范工作。</div>
      </div>
      <div style="font-family:宋体;text-indent: 2em;font-size: 10.5pt;">
        <div style="line-height:1.8">二、严格保守在中国化学工程集团有限公司（简称“集团公司”）工作期间接触和知悉的任何国家秘密、商业秘密和工作秘密。保证不以任何理由、形式将掌握、知悉的国家秘密、商业秘密和工作秘密违法违规泄露给前往国家或地区任何组织和人员。</div>
      </div>
      <div style="font-family:宋体;text-indent: 2em;font-size: 10.5pt;line-height:2.2">三、已清楚知道，因个人故意或过失行为，将导致或可能触犯《中华人民共和国刑法》规定的窃取、刺探、非法提供、非法持有、泄露国家秘密等罪行，并可能承担相应刑事责任。</div>
      <div style="font-family:宋体;text-indent: 2em;font-size: 10.5pt;line-height:2.2">
        四、严格遵守保密纪律和反奸防谍规章制度。不违规携带任何涉密资料、设备和载体出国（境）。在外期间，不使用个人电子设备存储、处理涉密或敏感信息；不随意谈论涉密事项，不使用手机、普通电话、微信等互联网通讯工具谈论涉密事项，不在无保密条件的场所谈论涉密事项，不议论所在国和第三国的敏感问题。
      </div>
      <div style="font-family:宋体;text-indent: 2em;font-size: 10.5pt;line-height:2.2">
        五、严格遵守外事纪律和团组规章制度，服从团组管理：严格遵守请销假制度，未经批准不单独外出；遵守出访国家（地区）法律法规，尊重出访国家（地区）风俗、文化。
      </div>
      <div style="font-family:宋体;text-indent: 2em;font-size: 10.5pt;line-height:2.2">
        六、严格遵守生活纪律，不进入涉黄、赌、毒等场所，不参加与身份不符的活动，不私自参加境外或有境外背景的组织，慎重交友聚会，对各类游行、抗议等活动，做到不参与、不围观，不私自对外发表言论，不私自接受采访。
      </div>
      <div style="font-family:宋体;text-indent: 2em;font-size: 10.5pt;line-height:2.2">
        七、严格遵守请示报告制度，如遇到境外组织和个人对本人或其他出访人员进行盘查、纠缠、威胁、拉拢、蛊惑、渗透、策反、资助、非官方馈赠等情况，及时向带队领导和我驻外使领馆报告，并在回国后及时向国家安全保密机关和集团公司报告，不隐瞒事关国家安全保密方面的情况或事项。
      </div>
       <div style="font-family:宋体;text-indent: 2em;font-size: 10.5pt;line-height:2.2">
         八、回国后积极配合国家安全保密机关和集团公司的回访工作。
      </div>
       <div style="font-family:宋体;text-indent: 2em;font-size: 10.5pt;line-height:2.2">九、若违反上述承诺，自愿承担党纪、政纪和法律责任。</div>
      <div
        style="margin-top:50pt;orphans:0; text-align:justify; text-indent:186pt; widows:0"
      >
        <span style="font-family:宋体; font-size:11pt">承诺人：</span>
      </div>
      <p
        style="margin-right:4em; margin-top:25pt;orphans:0; text-align:right;widows:0"
      >
        <span style="font-family:宋体; font-size:10.5pt"><input v-model="currentYear" style="border:none;width: 1.6cm;text-align:center;font-size: 10.5pt;">年</span>
        <span style="font-family:宋体; font-size:10.5pt"><input v-model="currentMonth" style="border:none;width: 1.4cm;text-align:center;font-size: 10.5pt;">月</span>
        <span style="font-family:宋体; font-size:10.5pt"><input v-model="currentDay" style="border:none;width: 1.4cm;text-align:center;font-size: 10.5pt;">日</span>
      </p>
    </div>
    <el-row type="flex" justify="space-around">
      <el-button type="warning" @click="printHandler" style="width: 400px;font-size: 24px">打印</el-button>
    </el-row>
    <div style="text-align: center">
      <span>版权所有：中国化学工程集团(股份)有限公司 | <a href="https://beian.miit.gov.cn/" target="_blank">京ICP备17025820号-5</a> | 版本号：{{this.versionNumber}}<!-- | 技术支持：北京赛鼎科技有限公司 --></span>
    </div>
  </div>
</template>
<script>
import print from "print-js";
import {mapGetters} from "vuex";
export default {
  name: "PromiseText",
  computed: {
    ...mapGetters(["versionNumber"])
  },
  data() {
    return {
     currentYear: '',
     currentMonth: '',
     currentDay: ''
    };
  },
  methods: {
    printHandler(){
      print({
        printable: "print",
        type: "html",
        scanStyles: false,
        documentTitle: "承诺书"
      })
    }
  },
  mounted(){
    let d=new Date()
    this.currentYear = d.getFullYear()
    this.currentMonth = d.getMonth()+1;
    this.currentDay = d.getDate()
  }
};
</script>
